import * as React from 'react';

interface ImageContainerProps {
  imageUrl: string;
  flexBasis: string;
  scale?: number;
  style?: React.CSSProperties;
}

function ImageContainer({
  imageUrl,
  flexBasis,
  scale = 100,
  style = {},
}: ImageContainerProps) {
  return (
    <div className="h100" style={{ flexBasis }}>
      <div
        className="contain bg-center"
        style={{
          ...style,
          paddingBottom: `${scale}%`,
          backgroundImage: `url("${imageUrl}")`,
        }}
      />
    </div>
  );
}

export default function Testemonials() {
  return (
    <React.Fragment>
      <section className="bg-white flex flex-wrap items-start items-center-l justify-around black pv5">
        <div className="pv4 ph3 w-40-l w-40-m w-80 flex flex-row-l items-center justify-center flex-column">
          <div
            className=" br-pill overflow-hidden"
            style={{ minWidth: '100px' }}
          >
            <div
              className="aspect-ratio--1x1"
              style={{
                backgroundImage: `url("${require('../../../../assets/img/a_mellbye.jpg')}"`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
          </div>
          <div className="ml4-l w6">
            <p className="tl lh-copy w-100 mb3 i mw6 mingl-gray">
              Mingl makes it easy (and more fun) to share my contact
              information. I love the reactions I get when I pull out my QR code
              and my contact information with my picture magically pops up on
              people’s screens!
            </p>
            <p className="tc ma0 ttu tracked b f7" style={{ color: '#252525' }}>
              Anette Mellbye
            </p>
            <p className="tc ma0 f7" style={{ color: '#424242' }}>
              Partner at Bull &#38; Co
            </p>
          </div>
        </div>
        <div className="pv4 ph3 w-40-l w-40-m w-80 flex flex-row-l items-center justify-center flex-column">
          <div
            className=" br-pill overflow-hidden"
            style={{ minWidth: '100px' }}
          >
            <div
              className="aspect-ratio--1x1"
              style={{
                backgroundImage: `url("${require('../../../../assets/img/Edit_Bihari.jpeg')}"`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
          </div>
          <div className="ml4-l w6">
            <p className="tl lh-copy w-100 mb3 i mw6 mingl-gray">
              Not only moving business introduction to a more innovative level
              but also helping with the sustainability agenda by saving paper
              and forest.
            </p>
            <p className="tc ma0 ttu tracked b f7" style={{ color: '#252525' }}>
              Edit König-Bihari
            </p>
            <p className="tc ma0 f7" style={{ color: '#424242' }}>
              Telenor Group Trading Desk
            </p>
          </div>
        </div>
        <div className="pv4 ph3 w-40-l w-40-m w-80 flex flex-row-l items-center justify-center flex-column">
          <div
            className=" br-pill overflow-hidden"
            style={{ minWidth: '100px' }}
          >
            <div
              className="aspect-ratio--1x1"
              style={{
                backgroundImage: `url("${require('../../../../assets/img/Nathan_Gold.png')}"`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
          </div>
          <div className="ml4-l w6">
            <p className="tl lh-copy w-100 mb3 i mw6 mingl-gray">
              I love to network and I cannot stand carrying or handing out
              business cards. Mingl makes it delightful to share your contact
              information with anyone.
            </p>
            <p className="tc ma0 ttu tracked b f7" style={{ color: '#252525' }}>
              Nathan Gold
            </p>
            <p className="tc ma0 f7 " style={{ color: '#424242' }}>
              The Demo Coach
            </p>
          </div>
        </div>
      </section>

      <section className="flex justify-around ph3 pt3 pb5 bg-white center flex-nowrap-l flex-wrap w-100 items-center">
        <div className=" w-50">
          <ImageContainer
            scale={50}
            flexBasis="300px"
            style={{ margin: '0 auto', maxWidth: '250px' }}
            imageUrl={`${require('../../../../assets/img/Logo_Sands.png')}`}
          />
        </div>
        <div className=" w-50">
          <ImageContainer
            scale={40}
            flexBasis="300px"
            style={{ margin: '0 auto', maxWidth: '250px' }}
            imageUrl={`${require('../../../../assets/img/Logo_Bull.png')}`}
          />
        </div>

        <div className=" w-50">
          <ImageContainer
            scale={30}
            flexBasis="300px"
            style={{ margin: '0 auto', maxWidth: '250px' }}
            imageUrl={`${require('../../../../assets/img/Logo_Moller.png')}`}
          />
        </div>
        <div className=" w-50">
          <ImageContainer
            scale={50}
            flexBasis="300px"
            style={{ margin: '0 auto', maxWidth: '250px' }}
            imageUrl={`${require('../../../../assets/img/Logo_Intek.png')}`}
          />
        </div>
      </section>
    </React.Fragment>
  );
}
